import { render, staticRenderFns } from "./KnMoveGroupAToGroupB.vue?vue&type=template&id=7ab06a96&scoped=true"
import script from "./KnMoveGroupAToGroupB.js?vue&type=script&lang=js&external"
export * from "./KnMoveGroupAToGroupB.js?vue&type=script&lang=js&external"
import style0 from "./KnMoveGroupAToGroupB.vue?vue&type=style&index=0&id=7ab06a96&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ab06a96",
  null
  
)

export default component.exports